<template>
  <div class="table-dark-bg box-shadow cart-table-wrapper return-confirmation">
    <div class="order-summary pt-3 box-shadow">
      <b-row class="px-3 mb-3">
        <b-col class="col">
          <h6 class="mb-0 fw-normal" v-text="Title"></h6>
        </b-col>
        <b-col class="col text-right">
          <h6 class="mb-0 fw-normal" v-text="itemCount + ' Item(s)'"></h6>
        </b-col>
      </b-row>

      <div class="order-items mt-3">
        <b-table
          striped
          :fields="fields"
          :items="itemList"
          class="table cart-table table-dark px-5"
          style="line-height: 16px;"
        >
          <template v-slot:cell(#)="data" class="sticky">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(product)="data">
            <div v-html="data.item.p_name" />
          </template>
          <template v-slot:cell(total)="data">
            <div v-html="currencySymbol + formatAmount(data.item.total)" />
          </template>
        </b-table>

        <!-- <b-row class="mb-2 head sticky-top px-3">
          <b-col md="1" class="p-0 text-left text">#</b-col>
          <b-col md="5" class="text-left text">
            Product(s) Name
          </b-col>
          <b-col md="2" class="text-center text">Qty.</b-col>
          <b-col md="4" class="text-right pr-0 text">Net Price</b-col>
          <div class="clearfix"></div>
        </b-row>
        <b-row
          class="mb-2 px-3"
          v-for="(item, id) in itemList"
          v-bind:key="item.name"
        >
          <b-col md="1" class="p-0 text-left">
            <span class="pr-0" v-text="id + 1"></span>
          </b-col>
          <b-col md="5" class="text-left order-summary-list">
            <ul class="p-0">
              <li v-text="item.p_name"></li>
            </ul>
          </b-col>
          <b-col md="2" class="text-center" v-text="item.qty"></b-col>
          <b-col md="4" class="text-right pr-0"
            ><span v-text="currencySymbol + item.total"></span
          ></b-col>
          <div class="clearfix"></div>
        </b-row> -->
      </div>

      <hr />

      <div class="card total-cart-amount border-0 px-3 pb-3">
        <div class="card-body p-0">
          <div class="cart-total">
            <b-row
              class="mb-1"
              v-for="summry in orderSummary"
              :key="summry.name"
            >
              <div class="col light" v-if="summry.last == 0">
                <p
                  v-if="summry.display_text != 'Total Refund'"
                  v-text="summry.display_text"
                />
              </div>
              <div class="col text-right" v-if="summry.last == 0">
                <p
                  v-if="summry.display_text != 'Total Refund'"
                  v-text="currencySymbol + formatAmount(summry.value)"
                />
              </div>
            </b-row>
          </div>
          <b-row class="mt-3 total py-3">
            <div class="col light p-0">
              <p
                class="p-0 mb-0 mt-1"
                v-text="orderSummary[orderSummary.length - 1].display_text"
              />
            </div>
            <div class="col text-right p-0">
              <h6
                class="mb-0 p-0 "
                style="font-size: 1.3rem;"
                v-text="
                  currencySymbol +
                    formatAmount(orderSummary[orderSummary.length - 1].value)
                "
              />
            </div>
          </b-row>
          <!-- <b-row class="mt-3">
            <div class="col light">
              <p>{{ orderSummary[orderSummary.length - 1].display_text }}</p>
            </div>
            <div class="col text-right">
              <h6 class="mb-0">₹ {{ orderSummary[orderSummary.length - 1].value }}</h6>
            </div>
          </b-row>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "return-order-summary",
  data() {
    return {
      Title: "Return Summary",
      id: 0,
      fields: [
        {
          key: "#",
          label: "#",
          class: "text-left w-2 pl-3",
        },
        {
          key: "p_name",
          label: "Product Name(s)",
          class: "text-left w-30",
        },
        {
          key: "qty",
          label: "Qty.",
          class: "text-center w-10",
        },
        // {
        //   key: "unit_price",
        //   label: "Unit Price",
        //   class: "text-center w-10",
        // },

        // {
        //   key: "sale_price",
        //   label: "Sale Price",
        //   class: "text-center w-10",
        // },
        // {
        //   key: "discount",
        //   label: "Discount",
        //   class: "text-center w-10",
        // },
        // {
        //   key: "tax",
        //   label: "Tax",
        //   class: "text-center w-10",
        // },
        {
          key: "total",
          label: "Net Price",
          class: "text-right w-10 pr-3",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
      returnData() {
        if (this.state.billing.billing.return_flow.return_invoice != "") {
          return this.state.billing.billing.return_flow.return_invoice;
        } else {
          return this.state.billing.billing.return_flow.return_confirm_data;
        }
      },
    }),
    itemCount() {
      return this.returnData.order_summary.item_qty;
    },
    itemList() {
      return this.returnData.order_summary.items;
    },
    orderSummary() {
      let data = [];
      this.returnData.order_summary.summary.map((item) => {
        if (item.name != "total_payable") {
          item.last = 0;
          data.push(item);
        } else {
          item.last = 1;
          data.push(item);
        }
      });
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.payment-methods h6 {
  font-size: 0.8rem;
}

.total {
  padding: 10px 15px;
  border: 1px #c0c0c0 solid;
  margin: 0px !important;
  border-radius: 5px;
}
.order-summary {
  h6 {
    font-size: 13px;
  }
}
</style>
